import { render, staticRenderFns } from "./HandlePlanLegacy.vue?vue&type=template&id=47a5dedc&scoped=true&"
import script from "./HandlePlanLegacy.vue?vue&type=script&lang=js&"
export * from "./HandlePlanLegacy.vue?vue&type=script&lang=js&"
import style0 from "./HandlePlanLegacy.vue?vue&type=style&index=0&id=47a5dedc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5dedc",
  null
  
)

export default component.exports